module.exports = __webpack_public_path__ + "static/Front_exterior_of_Freemasons_Hall_London-8bb5ece7cead8c93996f18899055636f.jpg";